import { makeStyles } from '@mui/styles'
import PageData from '@v4/utils/data/PageData'

const useStyles = makeStyles(
	theme => {
		const isWhite = ({ white, pageType }, withShadow = false) => {
			if (withShadow && PageData.isTypeResultPdf(pageType)) {
				return false
			}
			return white === true || (white === 'theme' && theme.palette.whiteText)
		}

		const calcColorFromSx = (props, breakpointValue) => {
			const white = props.sx?.white?.[breakpointValue]

			if (white === undefined) return null

			return isWhite({ ...props, white })
				? '#FFFFFF'
				: theme.palette.calcContrastColor(
						theme.palette.scoreapp.primary,
						props.usePaperColors ? theme.palette.background.paper : theme.palette.background.default,
				  )
		}

		function createBreakpoints(createStyles) {
			const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl']

			return _.reduce(
				breakpoints,
				(acc, breakpointValue) => {
					acc[theme.breakpoints.down(breakpointValue)] = createStyles(breakpointValue)

					return acc
				},
				{},
			)
		}

		const textShadowFrom = props => (isWhite(props, true) || props.shadow ? '0 0 4px rgb(0 0 0 / 40%)' : null)

		const mobileTextShadowFrom = (props, breakpointValue) => {
			const white = props.sx?.white?.[breakpointValue]
			const shadow = props.sx?.shadow?.[breakpointValue]

			if (white === undefined && shadow === undefined) return null

			const isShadow = shadow ?? props.shadow

			return isWhite({ ...props, white: white ?? props.white }, true) || isShadow
				? `0 0 4px rgb(0 0 0 / ${props.textShadow}%)`
				: 'none'
		}

		return {
			root: {
				width: '100%',
				color: props =>
					isWhite(props)
						? '#FFFFFF'
						: theme.palette.calcContrastColor(
								theme.palette.scoreapp.primary,
								props.usePaperColors
									? theme.palette.background.paper
									: theme.palette.background.default,
						  ),
				display: 'flex',
				alignItems: 'center',
				textTransform: 'uppercase',
				position: 'relative',
				zIndex: 1,
				'&:before, &:after': {
					content: '""',
					display: 'block',
					width: 1,
					flexGrow: 1,
					borderBottom: '1px dashed currentColor',
				},
				...createBreakpoints(breakpointValue => ({
					color: props => calcColorFromSx(props, breakpointValue),
				})),
			},
			icon: {},
			button: {
				color: 'inherit',
				flexShrink: 0,
				fontFamily: 'Instrument Sans',
				padding: theme.spacing(0.5, 1.5),
				fontSize: theme.spacing(1.5),
				margin: theme.spacing(0, 1.5),
				maxWidth: `calc(100% - ${theme.spacing(3)})`,
				fontWeight: 500,
				textShadow: props => textShadowFrom(props),
				background: 'transparent !important',
				border: '1px solid transparent',
				transition: theme.transitions.create(['border-color']),
				'&:hover': {
					borderColor: 'currentColor',
				},
				'& $icon': {
					marginRight: 2,
					'& svg': {
						fontSize: theme.spacing(1.5),
					},
				},
				...createBreakpoints(breakpointValue => ({
					textShadow: props => mobileTextShadowFrom(props, breakpointValue),
				})),
			},
		}
	},
	{ name: 'EditableContainer' },
)

export default useStyles
